export default class Tabs {
  constructor() {
    this.initTabs();
  }

  initTabs() {
    $(document).ready(function () {
      if ($(".tabset").length > 0) {
        let tabPanels = $(".tabset__tab-panel");
        let tabLinks = $(".c-subnav__li");

        for (let i in tabPanels) {
          if (tabPanels.hasOwnProperty(i)) {
            if (i > 0) {
              $(tabPanels[i]).hide();
            } else {
              $(tabLinks[i]).addClass("active");
            }
          }

        }

        tabLinks.click(function (e) {
          e.preventDefault();

          let target = $("#" + $(this).attr("data-action"));
          $("html, body").animate({ scrollTop: 0 }, "slow");

          if ((target).is(":hidden")) {
            tabPanels.hide();
            tabLinks.removeClass("active");
            target.fadeIn();
            $(this).addClass("active");
          }
        })
      }
    });
  }
}



